module.exports = __webpack_public_path__ + "static/media/slide-1.603beea2.svg";